<template>
    <v-container fluid grid-list-lg>
        <v-layout>
            <v-flex>
                <h1 class="display-3">Gestión de ingenieria de productos</h1>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex>
                <file-pond ref="pond" allow-multiple="true" multiple @processfile="tabla()"></file-pond>
                <v-data-table
                        :headers="headers"
                        :items="items"
                        :pagination.sync="pag"
                        :total-items="totalItems"
                        :loading="loading"
                        no-data-text="No hay datos"
                        disable-initial-sort
                        class="tabla-compacta-col"
                >
                    <template slot="items" slot-scope="props">
                        <td class="text-xs-center">
                            <v-menu offset-y>
                                <v-chip :color="props.item.estado.color" text-color="white" slot="activator">
                                    <v-avatar>
                                        <v-icon>{{ props.item.estado.icono }}</v-icon>
                                    </v-avatar>
                                    {{ props.item.estado.desig }}
                                </v-chip>
                                <v-list>
                                    <template v-for="e in estados">
                                        <v-list-tile @click="estadoSet(props.item.id,e.id)">
                                            <v-list-tile-action>
                                                <v-icon :color="e.color">{{ e.icono }}</v-icon>
                                            </v-list-tile-action>
                                            <v-list-tile-title>{{ e.desig }}</v-list-tile-title>
                                        </v-list-tile>
                                    </template>
                                </v-list>
                            </v-menu>
                        </td>
                        <td class="text-xs-center">{{ props.item.created_at }}</td>
                        <td class="text-xs-center">{{ props.item.updated_at }}</td>
                        <td class="text-xs-center">{{ props.item.user.name }}</td>
                        <td class="text-xs-center">{{ props.item.presupuesto_id }}</td>
                        <td class="text-xs-center">{{ props.item.presupuesto_items_id }}</td>
                        <td class="text-xs-center">{{ props.item.original }}</td>
                        <td class="text-xs-center">
                            <v-btn flat icon color="orange" @click.native="download(props.item)">
                                <v-icon>cloud_download</v-icon>
                            </v-btn>
                            <v-btn v-if="props.item.estado_id === 1" flat icon color="red" @click.native="destroy(props.item.id)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import {mapActions} from 'vuex';
    import vueFilePond, {setOptions} from 'vue-filepond';
    import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type/dist/filepond-plugin-file-validate-type.esm.js';
    import FilePondPluginImagePreview from 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.esm.js';
    import 'filepond/dist/filepond.min.css';
    import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

    const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);

    export default {
        name: "item",
        components: {FilePond},
        data() {
            return {
                loading: false,
                headers: [
                    {text: 'Estado', value: 'estado_id', align: 'center'},
                    {text: 'Fecha Creación', value: 'created_at', align: 'center'},
                    {text: 'Fecha Actualización', value: 'updated_at', align: 'center'},
                    {text: 'Usuario', value: 'user_id', align: 'center'},
                    {text: 'Presupuesto', value: 'presupuesto_id', align: 'center'},
                    {text: 'Item del presupuesto', value: 'presupuesto_items_id', align: 'center'},
                    {text: 'Archivo', value: 'original', align: 'center'},
                ],
                items: [],
                pag: {},
                totalItems: 0,
                estados: []
            }
        },
        watch: {
            pag: {
                handler() {
                    this.tabla();
                },
                deep: true
            }
        },
        mounted() {
            setOptions({
                instantUpload: true,
                labelFileWaitingForSize: 'Aguardando información de tamaño',
                labelIdle: 'Arrastre y suelte sus archivos o haga click para buscarlos en su pc',
                labelFileLoading: 'Cargando',
                labelFileLoadError: 'Error durante carga',
                labelFileProcessing: 'Subiendo',
                labelFileProcessingComplete: 'Subida completa',
                labelButtonProcessItem: 'Subir',
                labelTapToCancel: 'Click para cancelar',
                labelTapToRetry: 'Click para reintentar',
                labelTapToUndo: 'Click para deshacer',
                labelButtonRemoveItem: 'Quitar',
                labelButtonRetryItemLoad: 'Reintentar',
                labelButtonAbortItemProcessing: 'Canelar',
                labelButtonUndoItemProcessing: 'Deshacer',
                labelButtonRetryItemProcessing: 'Reintentar',
                server: {
                    url: window.Laravel.urlBase + '/api/presupuesto/ingenieria/' + this.$route.params.id,
                    process: {
                        url: '/process',
                        headers: {
                            'X-CSRF-TOKEN': window.Laravel.csrfToken,
                            'Authorization': 'Bearer ' + this.$ls.get('token')
                        }
                    },
                    revert: (uniqueFileId, load, error) => {
                        this.$http.delete('presupuesto/ingenieria/revert', {
                            params: {
                                id: uniqueFileId,
                                presupuesto_items_id: this.$route.params.id
                            }
                        })
                            .then(r => {
                                load();
                            })
                            .catch(err => {
                                error(err);
                            });
                    }
                }
            });
            this.estadosGet();
        },
        methods: {
            ...mapActions('notif', ['msjShow']),
            destroy(item_id) {
                this.loading = true;
                this.$http.post('presupuesto/ingenieria/destroy', {id: item_id})
                    .then(r => {
                        this.msjShow(r.data);
                        this.tabla();
                    })
                    .catch(err => {
                        this.loading = false;
                        this.msjShow({txt: 'Error al traer estados', tipo: 'error'})
                    })
            },
            estadoSet(item_id, estado_id) {
                this.loading = true;
                this.$http.post('presupuesto/ingenieria/estado-set', {
                    id: item_id,
                    estado_id: estado_id
                })
                    .then(r => {
                        this.msjShow(r.data);
                        this.tabla();
                    })
                    .catch(err => {
                        this.loading = false;
                        this.msjShow({txt: 'Error al traer estados', tipo: 'error'})
                    })
            },
            estadosGet() {
                this.$http.post('presupuesto/ingenieria/estados')
                    .then(r => {
                        this.estados = r.data;
                    })
                    .catch(err => {
                        this.msjShow({txt: 'Error al traer estados', tipo: 'error'})
                    })
            },
            download(item) {
                window.open(window.Laravel.urlBase + '/presupuesto/ingenieria/download/' + item.id, '_blank');
            },
            tabla() {
                this.loading = true;
                this.pag.presupuesto_items_id = this.$route.params.id;
                this.$http.post('presupuesto/ingenieria/tabla', this.pag)
                    .then(r => {
                        this.items = r.data.data;
                        this.totalItems = r.data.total;
                        this.loading = false;
                    }, err => {
                        this.loading = false;
                    })
            }
        }

    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/pages/presup/ingenieria.vue